import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Message from '../../../../../../common/Message';
import Loader from '../../../tracking/trackingLoading.gif';
import LoadingButton from '../../../../../../common/LoadingButton';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import { bodyIssueTicketGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { validationBodyGenerator } from '../../../../../../../helpers/tickets/SelfService';
import {
  createTicketNoProduct,
  validateProductByMotive,
} from '../../../../../../../redux/actions/TicketActions';
import { useNotReceivedStyles } from './styles';
import { notReceivedProductErrorMsg } from '../../../../../../../constants/Messages';

const NotReceived = ({ ...props }) => {
  const { mobile, type, motiveId } = props;
  const classes = useNotReceivedStyles({ mobile });
  const [comment, setComment] = useState('');
  const [checked, setChecked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [commentHelper, setCommentHelper] = useState('0/200');
  const [error, setError] = useState(false);

  const {
    validationStatus,
    validation,
    messageResponse,
    showForm,
    ticketNoProductStatus,
  } = useSelector((innerState) => innerState.ticketReducer);
  const { profile } = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (mobile) {
      const body = validationBodyGenerator(props);
      dispatch(validateProductByMotive(motiveId, body));
    }
  }, []);

  const handleClick = () => {
    const body = bodyIssueTicketGenerator({
      profile,
      type,
      comment,
      motiveId,
    });
    dispatch(createTicketNoProduct(body));
  };

  const changeComment = (event) => {
    const { value } = event.target;
    if (value.length > 200 || value.length < 10) {
      setError(true);
      setSuccess(false);
    } else {
      setError(false);
      setSuccess(true);
    }
    setComment(value);
    setCommentHelper(`${value.length}/200`);
  };

  return (
    <React.Fragment>
      {validationStatus === 'validating' && (
        <Box className={classes.containerLoader}>
          <img src={Loader} className={classes.loader} />
        </Box>
      )}

      {validationStatus === 'error' && (
        <Box className={classes.container}>
          <Message
            severity="info"
            fullRounded
            message={notReceivedProductErrorMsg(validation.id)}
          />
        </Box>
      )}

      {validationStatus === 'succeded' && (
        <Box className={classes.container}>
          {messageResponse !== '' && (
            <Message fullRounded severity="info" message={messageResponse} />
          )}
          {showForm && (
            <>
              <AppInput
                name="comment"
                label="Cuéntanos el inconveniente"
                value={comment}
                onClick={() => {}}
                onBlur={changeComment}
                onChange={changeComment}
                success={success}
                helperText={commentHelper}
                error={error}
                multiline
              />
              <AuthorizeCheckbox
                idComplement="notReceived"
                disabled={!success}
                onCheck={() => setChecked(!checked)}
              />
              <LoadingButton
                className={classes.button}
                variant="contained"
                color="primary"
                name="SentNotReceived"
                text="Enviar autorización"
                onClick={handleClick}
                disabled={!success || !checked}
                loading={ticketNoProductStatus === 'loading'}
              />
            </>
          )}
        </Box>
      )}
    </React.Fragment>
  );
};

NotReceived.propTypes = {
  mobile: PropTypes.bool,
  type: PropTypes.string,
  motiveId: PropTypes.string,
};

export default NotReceived;
